import React, { Component } from 'react'
import Constant, { getTypeTags } from '../../Constant'
import axios from 'axios'
import moment from 'moment'
import Swal from 'sweetalert2'
import Calendar from 'react-calendar'
import Loader from '../../common/Loader'

class EditBookingModel extends Component {
  state = {
    isLoading: false,
    booking_status: '',
    type_tag: '',
    comments: '',
    adult_tickets: '',
    child_tickets: '',
    slots: [],
    calendarData: [],
    slot_id: '',
    event_date: '',
    max_tickets: 0,
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
    if (event.target.name === 'event_date' && event.target.value) {
      this.getSlotsData(event.target.value)
    }
    if (event.target.name === 'slot_id' && event.target.value) {
      this.setMaxTickets(event.target.value)
    }
  }

  setMaxTickets = (slotId) => {
    const slotData = this.state.slots.find((slt) => slt.id == slotId)
    if (slotData) {
      this.setState({
        max_tickets: slotData.ticket_count,
      })
    }
  }

  componentDidMount = () => {
    this.setState(
      {
        type_tag: this.props.bookingDetails?.type_tag,
        booking_status: this.props.bookingDetails?.booking_status,
        comments: this.props.bookingDetails?.comments,
        adult_tickets: this.props.bookingDetails?.ticket_booked,
        child_tickets: this.props.bookingDetails?.child_ticket_booked,
        event_date: this.props.bookingDetails?.bookingDate,
        slot_id: this.props.bookingDetails?.eventBookingDetails?.eventSlotDetails?.id,
        booking_amount:
          this.props.bookingDetails?.paymentSummary?.booking_amount - this.props.bookingDetails?.extra_payment,
      },
      () => {
        this.getEventSlots(this.props.bookingDetails?.bookingDate)
        this.getSlotsData(this.props.bookingDetails?.bookingDate)
      }
    )
  }

  getEventSlots = async (date) => {
    this.setState({
      slots: [],
      calendarData: [],
      isLoading: true,
      max_tickets: 0,
    })
    const data = {
      event_id: this.props.bookingDetails?.eventBookingDetails?.id,
      date: moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
    }
    await axios
      .post(Constant.getAPI() + '/event/monthly-calendar', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            calendarData: res?.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getSlotsData = async (date) => {
    this.setState({
      slots: [],
      isLoading: true,
      max_tickets: 0,
    })
    const data = {
      event_id: this.props.bookingDetails?.eventBookingDetails?.id,
      date: date,
    }
    await axios
      .post(Constant.getAPI() + '/event/admin-monthly-calendar', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            slots: res?.data?.data || [],
          })
          this.setMaxTickets(this.state.slot_id)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  tileDisabled = (date) => {
    const checkIfDateExists = this.state.calendarData?.find(
      (ele) => ele.available && ele.event_date === moment(date.date).format('YYYY-MM-DD')
    )
    if (checkIfDateExists) {
      return false
    }
    return true
  }

  handleBookingDate = (event) => {
    this.setState(
      {
        event_date: moment(event).format('YYYY-MM-DD'),
      },
      () => {
        this.getSlotsData(moment(event).format('YYYY-MM-DD'))
      }
    )
  }

  handleMonthChange = (event) => {
    if (event?.activeStartDate) {
      let selectedDate = event.activeStartDate
      if (moment(selectedDate).month() == moment().month()) {
        selectedDate = moment().format('YYYY-MM-DD')
      } else {
        selectedDate = moment(selectedDate).format('YYYY-MM-DD')
      }
      this.setState(
        {
          event_date: selectedDate,
        },
        () => {
          this.getEventSlots(selectedDate)
          this.getSlotsData(selectedDate)
        }
      )
    }
  }

  render() {
    return (
      <div style={{ width: 800, paddingRight: 40 }}>
        {this.state.isLoading && (
          <Loader
            open={true}
            fullPage={true}
          />
        )}
        <div className="header">
          <b>Edit Booking</b>
        </div>
        <div className="body m-t-20">
          <div className="row">
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Type tag</label>
                <div className="col-9">
                  <select
                    name="type_tag"
                    className="form-control"
                    value={this.state.type_tag}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    {getTypeTags().map((itm) => (
                      <option
                        value={itm}
                        key={itm}
                      >
                        {itm}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Booking Status</label>
                <div className="col-9">
                  <select
                    name="booking_status"
                    className="form-control"
                    value={this.state.booking_status}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    <option value={'Confirmed'}>Confirmed</option>
                    <option value={'Cancelled'}>Cancelled</option>
                    <option value={'Successful'}>Successful</option>
                    <option value={'Postponed'}>Postponed</option>
                    <option value={'Pending'}>Pending</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Select Event Date</label>
                <div className="col-9">
                  <Calendar
                    value={this.state.event_date}
                    tileDisabled={(date) => this.tileDisabled(date)}
                    onChange={this.handleBookingDate}
                    onActiveStartDateChange={this.handleMonthChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Select Slot</label>
                <div className="col-9">
                  <select
                    name="slot_id"
                    className="form-control"
                    value={this.state.slot_id}
                    onChange={this.handleChange}
                    placeholder="Select Slot"
                  >
                    <option value={''}>Select Slot</option>
                    {this.state.slots?.map((itm) => (
                      <option
                        value={itm.id}
                        key={itm.id}
                      >
                        {itm.start_time}-{itm.end_time}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Adult tickets</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={this.state.adult_tickets}
                    name="adult_tickets"
                    onChange={this.handleChange}
                    min={0}
                  />
                  <div style={{ color: 'red' }}>Max allowed ticket to book is {this.state.max_tickets}</div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Child tickets</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={this.state.child_tickets}
                    name="child_tickets"
                    onChange={this.handleChange}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Total Booking Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter total amount"
                    value={this.state.booking_amount}
                    name="booking_amount"
                    onChange={this.handleChange}
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Comments</label>
                <div className="col-9">
                  <textarea
                    type="text"
                    className="form-control"
                    name="comments"
                    placeholder="Comments"
                    onChange={this.handleChange}
                    value={this.state.comments}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="text-right col-6 offset-6">
              <button
                onClick={() => this.props.editBooking(this.state)}
                className="btn hor-grd btn-grd-inverse offset-1"
                disabled={
                  this.state.booking_status == this.props.bookingDetails?.booking_status &&
                  this.state.type_tag == this.props.bookingDetails?.type_tag &&
                  this.state.comments == this.props.bookingDetails?.comments &&
                  this.state.adult_tickets == this.props.bookingDetails?.ticket_booked &&
                  this.state.child_tickets == this.props.bookingDetails?.child_ticket_booked &&
                  this.state.slot_id == this.props.bookingDetails?.eventBookingDetails?.eventSlotDetails?.id &&
                  this.state.event_date == this.props.bookingDetails?.bookingDate &&
                  this.state.booking_amount == this.props.bookingDetails?.paymentSummary?.booking_amount
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default EditBookingModel
